import React from 'react';
import { Section, CTAButton } from './Shared';
import { CheckCircle2, BookOpen, Target, Lightbulb, Video, Calendar, Repeat, Download, CheckSquare, ListTodo } from 'lucide-react';
export const Solution = () => {
  return <>
      <Section dark className="bg-black text-white" data-id="element-447">
        <div className="max-w-4xl mx-auto text-center" data-id="element-448">
          <h2 className="font-montserrat font-black text-3xl md:text-5xl uppercase leading-tight mb-8" data-id="element-449">
            Esto no es otro curso más
            <br data-id="element-450" />
            <span className="text-gold" data-id="element-451">
              Es el sistema que te lleva a la acción
            </span>
          </h2>

          <p className="text-xl md:text-2xl font-opensans mb-10 text-gray-300" data-id="element-452">
            No vas a aprender teoría infinita
            <br data-id="element-453" />
            <span className="font-bold text-white" data-id="element-454">Vas a tener:</span>
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12 text-left" data-id="element-455">
            {['Ideas listas para usar', 'Un sistema de contenido simple', 'Un planner práctico semanal', 'Pasos claros para publicar'].map((item, idx) => <div key={idx} className="bg-white/10 p-6 rounded-xl border border-white/20 flex items-center gap-4" data-id="element-456">
                <CheckCircle2 className="w-8 h-8 text-gold shrink-0" data-id="element-457" />
                <span className="font-montserrat font-bold text-xl" data-id="element-458">
                  {item}
                </span>
              </div>)}
          </div>

          <div className="inline-block border-b-4 border-coral pb-2" data-id="element-459">
            <p className="font-montserrat font-black text-3xl md:text-4xl uppercase" data-id="element-460">
              Menos pensar
              <br data-id="element-461" />
              <span className="text-coral" data-id="element-462">Más hacer</span>
            </p>
          </div>
        </div>
      </Section>

      <Section className="bg-gray-50" data-id="element-463">
        <div className="max-w-5xl mx-auto" data-id="element-464">
          <h2 className="font-montserrat font-black text-3xl md:text-5xl uppercase leading-tight text-center mb-16" data-id="element-465">
            Todo lo que necesitás para{' '}
            <span className="text-coral" data-id="element-466">empezar y sostener</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-467">
            {[{
            title: 'Módulo 1',
            desc: 'Mentalidad para dejar de bloquearte',
            icon: <Target className="w-8 h-8 text-coral" data-id="element-468" />
          }, {
            title: 'Módulo 2',
            desc: 'Cómo definir tu contenido sin complicarte',
            icon: <BookOpen className="w-8 h-8 text-coral" data-id="element-469" />
          }, {
            title: 'Módulo 3',
            desc: '100 ideas listas para publicar',
            icon: <Lightbulb className="w-8 h-8 text-coral" data-id="element-470" />
          }, {
            title: 'Módulo 4',
            desc: 'Cómo grabar sin miedo',
            icon: <Video className="w-8 h-8 text-coral" data-id="element-471" />
          }, {
            title: 'Módulo 5',
            desc: 'Sistema de organización semanal',
            icon: <Calendar className="w-8 h-8 text-coral" data-id="element-472" />
          }, {
            title: 'Módulo 6',
            desc: 'Cómo mantener constancia real',
            icon: <Repeat className="w-8 h-8 text-coral" data-id="element-473" />
          }].map((mod, idx) => <div key={idx} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-474">
                <div className="bg-coral/10 w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-475">
                  {mod.icon}
                </div>
                <h3 className="font-montserrat font-bold text-xl text-gray-400 mb-2" data-id="element-476">
                  {mod.title}
                </h3>
                <p className="font-montserrat font-bold text-xl text-black leading-tight" data-id="element-477">
                  {mod.desc}
                </p>
              </div>)}
          </div>

          <div className="bg-black text-white p-8 md:p-10 rounded-3xl mb-16" data-id="element-478">
            <h3 className="font-montserrat font-black text-2xl md:text-3xl text-gold mb-8 text-center uppercase" data-id="element-479">
              Extras Incluidos
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-480">
              {[{
              text: 'Planner descargable',
              icon: <Download className="w-6 h-6 text-gold" data-id="element-481" />
            }, {
              text: 'Checklist semanal',
              icon: <CheckSquare className="w-6 h-6 text-gold" data-id="element-482" />
            }, {
              text: 'Sistema de 30 días paso a paso',
              icon: <ListTodo className="w-6 h-6 text-gold" data-id="element-483" />
            }].map((extra, idx) => <div key={idx} className="flex items-center gap-3 bg-white/10 p-4 rounded-xl" data-id="element-484">
                  {extra.icon}
                  <span className="font-semibold" data-id="element-485">{extra.text}</span>
                </div>)}
            </div>
          </div>

          <CTAButton text="Quiero mi sistema de contenido ahora" data-id="element-486" />
        </div>
      </Section>

      <Section className="bg-white" data-id="element-487">
        <div className="max-w-3xl mx-auto text-center" data-id="element-488">
          <h2 className="font-montserrat font-black text-3xl md:text-5xl uppercase leading-tight mb-12" data-id="element-489">
            Lo que vas a lograr
          </h2>

          <ul className="space-y-6 text-left mb-12" data-id="element-490">
            {['Saber qué publicar sin dudar', 'Crear contenido en menos tiempo', 'Hablar frente a cámara con más seguridad', 'Publicar de forma constante', 'Empezar a construir tu marca personal'].map((item, idx) => <li key={idx} className="flex items-center gap-4 bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-491">
                <CheckCircle2 className="w-8 h-8 text-green-500 shrink-0" data-id="element-492" />
                <span className="font-opensans text-xl font-bold text-gray-800" data-id="element-493">
                  {item}
                </span>
              </li>)}
          </ul>

          <p className="font-montserrat font-black text-2xl md:text-3xl text-coral uppercase" data-id="element-494">
            Vas a pasar de consumir contenido a crearlo con claridad
          </p>
        </div>
      </Section>
    </>;
};